import React, { Component } from 'react';
import Loader from '../../Search/Loader';
import './Table.css'
import TableCaption from './TableCaption/TableCaption'
import TableRow from './TableRow/TableRow'
import TableCell from './TableCell/TableCell'

class Table extends Component {
    colNames = {
        'fjoldi': 'Fjöldi',
        'ordmynd': 'Orðmynd',
        'mark': 'Greiningarstrengur',
        'lemma': 'Uppflettimynd',
        'ordflokkur': 'Orðflokkur',
        'rodun' : 'Sæti í tíðniröð',
        'rodun_an_p' : 'Sæti í tíðniröð',
    };

    downloadAsCSV = (data) => {
        const cols = data.length > 0 && typeof(data[0] === 'object') ? Object.keys(data[0]) : [];
        let csvArray = ["data:text/csv;charset=utf-8," + cols.join(";")];
        data.forEach(item => {
            csvArray.push(Object.values(item).join(";"))
        })
        const csvData = csvArray.join("\r\n");
        const encodedCSV = encodeURI(csvData);
        const link = document.createElement("a");
        link.href = encodedCSV;
        link.download = "ordtidnigogn.csv";
        link.click();
    }


    render() {
        const list = this.props.listData
        const cols = list.length > 0 && typeof(list[0] === 'object') ? Object.keys(list[0]) : [];
        const elementList = list.map((item, index) => {
            return (
                <TableRow key={index+1}>
                    {cols.map((col) => {
                        return (
                            <TableCell key={col} type={col} val={item[col]} />
                        )
                    })}
                </TableRow>
            )
        })
        const tableHeader = (
            <tr>
                {/*<th>Sæti</th>*/}
                {cols.map((item) => {
                    return <th key={item}>{this.colNames[item] || item}</th>
                })}
            </tr>
        )
        return (
            <div className={'table-wrapper'}>
                <Loader loading={this.props.loading} extraClasses={'table-loader'} />
                <table
                    className={'table table-bordered table-striped'+(this.props.loading ? ' greyout' : '')}
                    id='results-table'
                >
                    {this.props.totalRows && !this.props.totalLoading ? (
                      <TableCaption
                        downloadAsCSV={this.props.showCSVModal}
                        totalRows={this.props.totalRows}
                        totalPages={this.props.getTotalPages()}
                        />) : null}
                    <tbody>
                        {cols.length ? tableHeader : null}
                        {elementList}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Table



// WEBPACK FOOTER //
// ./src/Components/Table/Table.js